import React, { useCallback } from 'react';
import classNames from 'classnames';
import { IStepperProps } from './Stepper.types';
import styles from './Stepper.module.css';

const Stepper: React.FC<IStepperProps> = ({ stepsCount, currentStep, handleSelect, className = '' }: IStepperProps) => {
  const onSelect = useCallback(
    (index: number) => () => {
      if (handleSelect) {
        handleSelect(index);
      }
    },
    [handleSelect]
  );

  const containerClassName = classNames(styles.stepperContainer, className);

  return (
    <div className={containerClassName}>
      {[...Array(stepsCount)].map((_, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          className={`${styles.step} ${index === currentStep ? styles.active : ''}`}
          onClick={onSelect(index)}
        />
      ))}
    </div>
  );
};

export default Stepper;
